<div class="share-buttons-container">
    <button type="button" class="btn btn-share" [popover]="sharePopover" placement="bottom" triggers="click" container="body">
        <i class="fas fa-share-nodes"></i>
    </button>

    <ng-template #sharePopover>
        <div class="share-popover-buttons">
            <button type="button" class="btn btn-twitter" (click)="onShareClick(websiteConstants.twitter.NAME)">
                <i class="fa-brands fa-twitter"></i>
            </button>

            <button type="button" class="btn btn-facebook" (click)="onShareClick(websiteConstants.facebook.NAME)">
                <i class="fa-brands fa-facebook"></i>
            </button>

            <button type="button" class="btn btn-pinterest" (click)="onShareClick(websiteConstants.pinterest.NAME)">
                <i class="fa-brands fa-pinterest"></i>
            </button>

            <button type="button" class="btn btn-reddit" (click)="onShareClick(websiteConstants.reddit.NAME)">
                <i class="fa-brands fa-reddit"></i>
            </button>

            <button type="button" class="btn btn-linkedin" (click)="onShareClick(websiteConstants.linkedIn.NAME)">
                <i class="fa-brands fa-linkedin"></i>
            </button>
        </div>
    </ng-template>
</div>
